'use client';
import { useState } from 'react';
import { Link } from '@/app_components/common/Link';
// biome-ignore lint/performance/noNamespaceImport: need for Popover
import * as Popover from '@/app_components/ui/Popover';
import { AnalyticsEvent, ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

const LearnMore = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Popover.Root open={isOpen}>
      <Popover.Trigger
        asChild
        className={AnalyticsEvent.ImpressionElement}
        data-cy={ContentPlacement.DisclosureStripe}
        onClick={handleClick}
      >
        <button
          className='cursor-pointer text-primary-hover'
          type='button'
        >
          Learn More.
        </button>
      </Popover.Trigger>
      <Popover.Content
        align='start'
        side='bottom'
      >
        <div className='absolute w-full min-w-60 -right-16 top-4 text-left border-[1px] bg-pure border-solid rounded-sm stroke-secondary flex flex-col shadow-md px-1 py-2'>
          <button
            aria-label='close-learn-more'
            className='icon icon-close-bold cursor-pointer self-end w-4 h-3'
            onClick={handleClick}
            type='button'
          />
          <div>
            Fortune earns a commission for purchases made from affiliate partners via some links on our site; other
            links are not affiliate partner links.{' '}
            <Link
              className='text-accent text-primary-hover'
              href='/advertiser-disclosure/'
            >
              Click here
            </Link>{' '}
            to read the full Fortune advertiser disclosure and how we earn commissions.
          </div>
        </div>
      </Popover.Content>
    </Popover.Root>
  );
};

// TODO: Fetch this from backend which is currently coming from the destination config
export const ArticleDisclosure = ({ className, children, ...rest }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'sticky top-[calc(var(--leaderboard-height)+var(--header-height))] z-body-overlay bg-primary px-5 py-2 border-b-1  md:text-base text-center md:text-center stroke-secondary',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

export const AffiliateDisclosure = () => (
  <>
    We have independently evaluated the products and services below. We may earn affiliate revenue from links in the
    content.{' '}
    <div className='inline-block border-b-[1px] hover:stroke-accent'>
      <LearnMore />
    </div>
  </>
);

export const CryptoDisclosure = () => <>Some Fortune Crypto pricing data is provided by Binance.</>;
